module.exports = __webpack_public_path__ + "img/40_00_075_873.90af8d22.jpg";